import React from "react";
import PropTypes from 'prop-types';
import OpsAlertsContent from "../../OpsAlerts/OpsAlertsContent";
import Page from "../../Components/Page";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../../Components/LoadingWrapper";

export const AlertTab = ({retailerId}) => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/opsAlertLogsByDate/?retailerId=${retailerId}`
    const {loading, data} = useServiceBase({endpointUrl});

    return (
        <Page name="Unacknowledged Alerts">
            <LoadingWrapper loading={loading}>
                <OpsAlertsContent url={endpointUrl} data={data}/>
            </LoadingWrapper>
        </Page>
    )
}

AlertTab.propTypes = {
    retailerId: PropTypes.number
}